import axios from 'axios'

export default {
  install(Vue, options) {
    /**
    * initialize HTTPClient
    */
    const HTTP = axios.create({
      baseURL: '/checkout/api/',
      validateStatus: function(status) {
        return status >= 200 && status < 500
      }
    })

    /**
     * resign new requests with current auth token
     */
    HTTP.interceptors.request.use(config => {
      return config
    })

    /**
     * error handling
     */
    const onError = e => {
      console.error('API HTTP Error', e)
    }

    /**
     * generic request
     */
    const request = async (method, url, data, params, cookie) => {
      try {
        console.log('[API]', { method, url, data, params, cookie })
        let headers = null
        if (cookie) headers = { Cookie: cookie }
        const response = await HTTP.request({ method, url, data, params, headers })
        if (response.status < 300) return response.data
      } catch (e) {
        onError(e)
      }
    }

    Vue.prototype.checkoutGet = async (url, params) => {
      const response = await request('get', url, null, params)
      return response
    }
  }
}



// WEBPACK FOOTER //
// ./src/checkout.js